import React from 'react'

const itemLabel = tickets => {
  if (tickets.gift) {
    return 'Gift Membership'
  } else {
    return 'Membership'
  }
}
function MembershipItem({ item }) {
  const labelTitle = itemLabel(item)
  return (
    <div
      className="mt-32 text-depths"
      key={item.id}
    >
      <p className="cta-label">
        {`${labelTitle}`}
      </p>
      <p className="mt-8 mb-0 font-light leading-normal text-16">
        {`${item.name} Membership x 1`}
      </p>
    </div>
  )
}

export default MembershipItem
